<template>
  <footer
    v-if="$route.name != 'Login' && $route.name != 'Register'"
    class="px-2 pb-2 fixed bottom-0 left-0 w-screen flex gap-1 z-50"
  >
    <button
      class="w-full h-14 mr-2 text-white"
      @click="$router.push({ name: 'Gallery' })"
    >
      가상전시공간
    </button>
    <button
      class="w-full h-14 text-white"
      @click="$router.push({ name: 'Album' })"
    >
      도감
    </button>
  </footer>
</template>

<style scoped>
footer {
  position: fixed;
  bottom: 0px;
  z-index: 9999;
}

button {
  background-color: #3c2515;
  border: solid #bfb8b4 1px;
}
</style>